import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DragSource } from 'react-dnd'
import ItemTypes from '../constants/ItemTypes'
import Dustbin from './Dustbin'
import AppStore from '../../../store/AppStore'
import AdministrationAction from '../../../administration/actions/AdministrationAction'

const style = {
	position: 'absolute',
	cursor: 'move',
	zIndex: 7
}

class BoxDustbin extends Component {
	constructor(props) {
		super(props)
		const box = { id: props.id, children: props.children, left: props.left, top: props.top }
		this.state = {
			boxes: [box]
		}
		this.addBox = this.addBox.bind(this)
		this.removeBox = this.removeBox.bind(this)
	}

	addBox(box) {
		this.setState(prevState => {
			return Object.assign({}, prevState, {
				boxes: prevState.boxes.concat([box])
			})
		})
	}

	removeBox(id) {
		AppStore.dispatch(AdministrationAction.removeLegend(id))
		this.setState(prevState => {
			return Object.assign({}, prevState, {
				boxes: prevState.boxes.filter(b => b.id !== id)
			})
		})
	}

	render() {
		const { hideSourceOnDrag, left, top, connectDragSource, isDragging } = this.props
		if (isDragging && hideSourceOnDrag) {
			return null
		}

		return connectDragSource(
			<div style={ { ...style, left, top } }>
				<Dustbin onAddBox={ this.addBox } onRemoveBox={ this.removeBox } boxes={ this.state.boxes }
						 left={ left } top={ top }/>
			</div>
		)
	}
}

BoxDustbin.propTypes = {
	connectDragSource: PropTypes.func.isRequired,
	isDragging: PropTypes.bool.isRequired,
	id: PropTypes.any.isRequired,
	left: PropTypes.number.isRequired,
	top: PropTypes.number.isRequired,
	hideSourceOnDrag: PropTypes.bool.isRequired,
	children: PropTypes.node
}

const boxSource = {
	beginDrag(props, monitor, component) {
		const boxes = component.state.boxes
		const { id, left, top } = props
		return { id, left, top, boxes }
	}
}

const collect = (connect, monitor) => {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	}
}

export default DragSource(ItemTypes.DUSTBIN_BOX, boxSource, collect)(BoxDustbin)



// WEBPACK FOOTER //
// ./src/components/drag/components/BoxDustbin.js